import { render, staticRenderFns } from "./CourseAttributeList.vue?vue&type=template&id=56d95207&"
import script from "./CourseAttributeList.vue?vue&type=script&lang=ts&"
export * from "./CourseAttributeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports